import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPhone, faEnvelope, faArrowRight, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import './Ubicacion.css';

export default function Ubicacion() {
    const infoContacto = {
        sucursalCba: "Av. Fuerza Aérea 3850, Córdoba Capital",
        sucursalRioCuarto: "Complejo Mercomax, Local 9 y 10, Río Cuarto",
        telefono: "+54 9 3513477034",
        email: "idosuzukiysubaru@gmail.com",
        horario: "Lunes a Viernes de 9 a 19 hs"
    };

    const handleDireccionesClick = () => {
        // Por defecto abre la sucursal de Córdoba Capital
        const direccionEncoded = encodeURIComponent(infoContacto.sucursalCba);
        window.open(`https://www.google.com/maps/search/?api=1&query=${direccionEncoded}`, '_blank');
    };

    return (
        <div className='ido-ubicacion-section'>
            <div className='ido-ubicacion-container'>
                <div className='ido-ubicacion-grid'>

                    {/* Columna de Información */}
                    <div className='ido-info-side'>
                        <div className='ido-badge'>ESTAMOS CERCA</div>
                        <h2 className='ido-section-title'>IDO SUZUKI & SUBARU</h2>
                        <p className='ido-section-desc'>
                            Explorá nuestro showroom y recibí asesoramiento personalizado para tu próximo vehículo en nuestras sucursales oficiales.
                        </p>

                        <div className='ido-contact-list'>
                            <div className='ido-contact-item'>
                                <span className='ido-contact-label'>CÓRDOBA CAPITAL</span>
                                <p><FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-red" /> {infoContacto.sucursalCba}</p>
                            </div>
                            <div className='ido-contact-item'>
                                <span className='ido-contact-label'>RÍO CUARTO</span>
                                <p><FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-red" /> {infoContacto.sucursalRioCuarto}</p>
                            </div>
                            <div className='ido-contact-item'>
                                <span className='ido-contact-label'>TELÉFONO</span>
                                <p><FontAwesomeIcon icon={faPhone} className="me-2 text-red" /> {infoContacto.telefono}</p>
                            </div>
                            <div className='ido-contact-item'>
                                <span className='ido-contact-label'>EMAIL</span>
                                <p><FontAwesomeIcon icon={faEnvelope} className="me-2 text-red" /> {infoContacto.email}</p>
                            </div>
                        </div>

                        <div className='ido-horarios-box'>
                            <FontAwesomeIcon icon={faClock} />
                            <span>{infoContacto.horario}</span>
                        </div>

                        <button className='ido-btn-maps' onClick={handleDireccionesClick}>
                            CÓMO LLEGAR A CÓRDOBA <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>

                    {/* Columna del Mapa */}
                    <div className='ido-map-side'>
                        <div className='ido-map-wrapper'>
                            {/* Iframe configurado con la dirección de Av. Fuerza Aérea 3850 */}
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3404.162725459345!2d-64.2374347!3d-31.4371587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9432a106e409b837%3A0xc3f6e919830500!2sAv.%20Fuerza%20A%C3%A9rea%20Argentina%203850%2C%20X5000%20C%C3%B3rdoba!5e0!3m2!1ses-419!2sar!4v1700000000000!5m2!1ses-419!2sar"
                                className='ido-iframe'
                                allowFullScreen=""
                                loading="lazy"
                                title="Ubicación IDO Córdoba"
                                style={{ border: 0 }}
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}